import React from 'react'
import { useTranslation } from 'react-i18next'
import { DataBlock, PersonBlock, Ellipsis } from '@fs/zion-ui'
import { css } from '@linaria/core'
import type { TfData } from '@fs/zion-tree-types'

const relatedPersonCss = css`
  margin-top: 4px;
`

export default function AncestorRelative({ ancestorData }: { ancestorData: Pick<TfData, 'person'> }): JSX.Element {
  const [t] = useTranslation()
  const firstSpouse = ancestorData?.person?.spouse?.[0]
  const firstParent = ancestorData?.person?.parent?.[0]
  const firstChild = ancestorData?.person?.children?.[0]

  const relative =
    (firstSpouse?.identifier !== 'UNKNOWN' && firstSpouse) ||
    (firstParent?.identifier !== 'UNKNOWN' && firstParent) ||
    (firstChild?.identifier !== 'UNKNOWN' && firstChild) ||
    undefined

  let relativeType = ''
  if (relative?.identifier === firstSpouse?.identifier) relativeType = t('ancestor-card.spouse.label')
  else if (relative?.identifier === firstParent?.identifier) relativeType = t('ancestor-card.parent.label')
  else if (relative?.identifier === firstChild?.identifier) relativeType = t('ancestor-card.child.label')

  const relatedPerson = (
    <div className={relatedPersonCss}>
      <PersonBlock
        name={<Ellipsis>{relative?.name}</Ellipsis>}
        size="sm"
        avatarSize="smaller"
        avatarProps={{
          src: relative?.image?.contentUrl,
          sex: relative?.gender?.toLowerCase() as Lowercase<NonNullable<typeof relative>['gender']> | undefined,
        }}
      />
    </div>
  )

  return <>{relative && <DataBlock heading={relativeType} data={relatedPerson} />}</>
}
